module.exports = __webpack_public_path__ + "static/media/19.ee8a089b.svg";